import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useContactFormSettings = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.CONTACT_FORM_SETTINGS(),
    queryFn: () => shopApi.fetchContactFormSettings(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.CONTACT_FORM_SETTINGS(),
    });
  };

  return {
    isLoading,
    isFetching,
    contactFormSettings: data?.data,
    invalidate,
  };
};
